module.exports = __webpack_public_path__ + "static/media/SmartShop_7-356w.a611f804.jpg";